<template>
    <div v-if="pageVisible" :class="['navbar-item', {selected: isActive}]">
        <InlineSvg v-if="showSeparator" class="divider-icon" :src="slashIcon" />
        <button
            :class="['btn', buttonStyle, {active: isActive}]"
            :data-text="label"
            @click="handleClick"
        >
            <span>{{ label }}</span>
        </button>
    </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
import slashIcon from "@/images/icon-slash-icon.svg";
import { mapGetters } from "vuex";
import {getPortfolioGenerationPreviewPath} from "@/scripts/view/portfolio/generationPreview.js";

export default {
    name: "PortfolioNavigationItem",
    components: { InlineSvg },
    props: {
        page: {
            type: Object,
            default: null,
        },
        index: {
            type: Number,
            default: 0,
        },
        buttonStyle: {
            type: [String, Array],
            default: "regular",
        },
        upperCase: {
            type: Boolean,
            default: false,
        },
        showSeparator: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters("view", ["viewData"]),
        portfolio() {
            return this.viewData?.portfolio;
        },
        label() {
            const name = this.page?.name || "";
            return this.upperCase ? name.toUpperCase() : name;
        },
        pageVisible() {
            return !!this.page;
        },
        isActive() {
            return this.viewData?.activePage === this.page?.shortId;
        }
    },
    methods: {
        rootIsOwnDomain() {
            return this.portfolio?.ownDomainAddress && location.origin.includes(this.portfolio.ownDomainAddress);
        },
        closeMobileNavigation() {
            this.viewData.navOpen = false;
        },
        handleClick() {
            if (!this.page) return;
            if (this.viewData?.activePage === this.page.shortId) {
                this.closeMobileNavigation();
                return;
            }

            switch (this.page.type) {
                case "home": {
                    const homeRoute = getPortfolioGenerationPreviewPath(this.$route)
                        || (this.rootIsOwnDomain()
                        ? "/"
                        : `/${this.portfolio.shortId}`);
                    this.$router.push(homeRoute);
                    this.closeMobileNavigation();
                    break;
                }
                case "file":
                case "link":
                case "mailto": {
                    const url = this.page?.settings?.link?.url;
                    if (!url) return;
                    const prefix = this.page.type === "mailto" ? "mailto:" : "";
                    const destination = `${prefix}${url}`;
                    if (this.page?.settings?.link?.openInNewTab) {
                        window.open(destination, "_blank", "noopener,noreferrer");
                    } else {
                        window.location.href = destination;
                    }
                    break;
                }
                default: {
                    const pageRoute = getPortfolioGenerationPreviewPath(this.$route, this.page.shortId)
                        || (this.rootIsOwnDomain()
                        ? `/p/${this.page.shortId}`
                        : `/p/${this.portfolio.shortId}/${this.page.shortId}`);
                    this.$router.push(pageRoute);
                    this.closeMobileNavigation();
                    break;
                }
            }
        },
    },
    data() {
        return {
            slashIcon,
        };
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/layouts/new-portfolio-layout/components/navbar-item";
</style>
